// $large-size: 1320px;
// $medium-size: 1024px;
// $small-size: 768px;
// $smallest-size: 480px;

export const breakpoints = {
  medium: 1024,
  tablet: 768,
  phone: 480
}

